import { element } from './util.ts';

const BIFROST_OVERLAY_ID = 'bifrost-overlay';

export const isBifrostOverlay = (target: EventTarget | null): boolean => {
  const el = element(target);
  return el?.id === BIFROST_OVERLAY_ID || !!el?.closest(`#${BIFROST_OVERLAY_ID}`);
};
